import { useQuery } from "@tanstack/react-query"
import { getProductCategoriesWithSubCategories, type ProductCategoryWithSubs } from "@/lib/api/product.api"
import { useAuthStore } from "@/store/auth.store"

export function useProductCategoriesWithSubs() {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery<ProductCategoryWithSubs[]>({
    queryKey: ["product-categories-with-subs"],
    queryFn: () => getProductCategoriesWithSubCategories(accessToken ?? undefined),
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchOnWindowFocus: false,
  })
}
